const personalities = [
  {
    id: 'shy',
    name: 'Shy',
    difficulty: 'Hard',
    description: 'Quiet, reserved, and takes time to open up. Prefers listening to talking and may struggle with initiating conversation.',
    traits: ['reserved', 'thoughtful', 'introspective', 'gentle', 'cautious'],
    interests: ['reading', 'solo activities', 'quiet environments', 'deep conversations'],
    conversationStyle: 'Hesitant, with frequent pauses. Speaks softly and often trails off mid-sentence. Rarely initiates new topics.'
  },
  {
    id: 'extrovert',
    name: 'Extrovert',
    difficulty: 'Easy',
    description: 'Outgoing, energetic, and loves being around people. Easily strikes up conversations and shares stories.',
    traits: ['talkative', 'enthusiastic', 'social', 'expressive', 'adventurous'],
    interests: ['group activities', 'parties', 'sports', 'travel', 'new experiences'],
    conversationStyle: 'Animated and full of energy. Often speaks quickly and at length. Asks lots of questions and shares personal anecdotes freely.'
  },
  {
    id: 'nerdy',
    name: 'Nerdy',
    difficulty: 'Medium',
    description: 'Intellectual and passionate about specific interests. Enjoys deep dives into topics and sharing knowledge.',
    traits: ['analytical', 'curious', 'detail-oriented', 'passionate', 'logical'],
    interests: ['technology', 'science', 'gaming', 'fantasy/sci-fi', 'collecting', 'puzzles'],
    conversationStyle: 'Detail-oriented with frequent references to niche interests. Gets excited when talking about favorite subjects and may use specialized terminology.'
  },
  {
    id: 'athletic',
    name: 'Athletic',
    difficulty: 'Medium',
    description: 'Active, health-conscious, and energetic. Values physical fitness and outdoor activities.',
    traits: ['disciplined', 'competitive', 'energetic', 'health-conscious', 'goal-oriented'],
    interests: ['sports', 'fitness', 'nutrition', 'outdoor activities', 'competition'],
    conversationStyle: 'Direct and sometimes competitive. Often relates experiences to sports or fitness. Uses action-oriented language.'
  },
  {
    id: 'guarded',
    name: 'Guarded',
    difficulty: 'Hard',
    description: 'Cautious with their heart after being hurt before. Tests the waters and holds back until they feel safe.',
    traits: ['cautious', 'protective', 'perceptive', 'reserved', 'loyal'],
    interests: ['emotional safety', 'trust-building', 'reading people', 'stability'],
    conversationStyle: 'Careful and measured, watching for inconsistencies or red flags. Warms up slowly as trust builds, but pulls back at the first sign something feels off.'
  },
  {
    id: 'confident',
    name: 'Confident',
    difficulty: 'Medium',
    description: 'Self-assured, decisive, and comfortable in most situations. May come across as arrogant at times.',
    traits: ['assertive', 'direct', 'ambitious', 'self-assured', 'decisive'],
    interests: ['leadership', 'achievement', 'status symbols', 'self-improvement'],
    conversationStyle: 'Bold and direct with strong opinions. Rarely shows doubt and may dominate conversations. Uses definitive language.'
  },
  {
    id: 'materialistic',
    name: 'Materialistic',
    difficulty: 'Hard',
    description: 'Status-conscious and focused on possessions, appearances, and financial success.',
    traits: ['status-conscious', 'brand-aware', 'image-focused', 'ambitious', 'judgmental'],
    interests: ['luxury brands', 'fine dining', 'high-end shopping', 'exclusive experiences'],
    conversationStyle: 'Name-drops brands and prices. Evaluates people and experiences based on their cost or status. Asks about career and possessions.'
  },
  {
    id: 'girlNextDoor',
    name: 'Girl Next Door',
    difficulty: 'Easy',
    description: 'Approachable, down-to-earth, and relatable. Values simplicity and authenticity.',
    traits: ['genuine', 'warm', 'unpretentious', 'relatable', 'friendly'],
    interests: ['simple pleasures', 'community', 'everyday activities', 'family'],
    conversationStyle: 'Casual and relatable. Uses everyday language and shares authentic experiences. Easy to talk to and makes others comfortable.'
  },
  {
    id: 'happyGoLucky',
    name: 'Happy-Go-Lucky',
    difficulty: 'Easy',
    description: 'Cheerful, optimistic, and carefree. Sees the best in people and situations.',
    traits: ['optimistic', 'cheerful', 'spontaneous', 'easy-going', 'playful'],
    interests: ['fun activities', 'jokes', 'adventures', 'trying new things'],
    conversationStyle: 'Upbeat and positive with frequent laughter. Doesn\'t dwell on problems and quickly shifts to positive topics.'
  },
  {
    id: 'mysterious',
    name: 'Mysterious',
    difficulty: 'Hard',
    description: 'Enigmatic, private, and slightly unpredictable. Reveals information slowly and carefully.',
    traits: ['private', 'observant', 'thoughtful', 'unpredictable', 'intriguing'],
    interests: ['psychology', 'art', 'philosophy', 'unusual experiences'],
    conversationStyle: 'Measured and selective. Asks probing questions but reveals little about themselves. Often speaks in ambiguous terms.'
  },
  {
    id: 'flirty',
    name: 'Flirty',
    difficulty: 'Easy',
    description: 'Playful, teasing, and openly romantic. Loves banter and isn\'t shy about showing interest.',
    traits: ['playful', 'bold', 'charming', 'teasing', 'affectionate'],
    interests: ['banter', 'romance', 'dancing', 'compliments', 'wordplay'],
    conversationStyle: 'Full of teasing remarks, double meanings, and compliments. Enjoys witty back-and-forth and pushes lightly for reciprocation.'
  },
  {
    id: 'workaholic',
    name: 'Workaholic',
    difficulty: 'Medium',
    description: 'Ambitious and career-driven, often distracted by work. Values hard work but struggles to switch off.',
    traits: ['driven', 'busy', 'ambitious', 'distracted', 'goal-oriented'],
    interests: ['career growth', 'productivity', 'networking', 'side projects'],
    conversationStyle: 'Replies can be delayed or short, often mentioning being busy or multitasking. Talks enthusiastically about work but has to be pulled toward other topics.'
  }
];

// Returns the personality list with any gender-specific labels adjusted
// (e.g. "Girl Next Door" reads as "Boy Next Door" when practicing with men).
export const getPersonalities = (gender) => {
  return personalities.map((personality) => {
    if (personality.id === 'girlNextDoor') {
      return {
        ...personality,
        name: gender === 'male' ? 'Boy Next Door' : 'Girl Next Door'
      };
    }
    return personality;
  });
};

export default personalities;
